import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import PopupCrossSellOfferCon from '../../../PopupCrossSellOfferCon';
import SlideoutFullpageProduct from './product';

import { StyledSlideoutFullpagePopupWidgetCon } from './skins';

export default function SlideoutFullpageLayout(props) {
  const {
    isMobile,
    primary,
    products,
    selectedVariantInfo,
    popupOfferHeaderStyles,
    popupOfferBottomBarStyles,
    theme,
    onAddClick,
    onMinimizeClick,
    onCheckoutClick,
    onSkipClick,
    isBottomBarButtonActionLoading,
    offerLevelQuantityAdded,
    offerLevelDiscountQuantity,
    atcStatus,
    ...restProps
  } = props;

  return (
    <StyledSlideoutFullpagePopupWidgetCon
      className={`mr-popup-widget mr-popup-widget--cross-sell-popup mr-popup-widget--${
        theme.popupType
      }-fullpage`}
    >
      <PopupCrossSellOfferCon
        renderInCarousel
        isMobile={isMobile}
        onAddClick={onAddClick}
        onMinimizeClick={onMinimizeClick}
        onCheckoutClick={onCheckoutClick}
        onSkipClick={onSkipClick}
        popupOfferHeaderStyles={popupOfferHeaderStyles}
        popupOfferBottomBarStyles={popupOfferBottomBarStyles}
        productsContainerPadding={theme.productsContainerPadding}
        productsContainerMargin={theme.productsContainerMargin}
        isBottomBarButtonActionLoading={isBottomBarButtonActionLoading}
        offerLevelQuantityAdded={offerLevelQuantityAdded}
        offerLevelDiscountQuantity={offerLevelDiscountQuantity}
      >
        {products.map((product, i) => (
          <Fragment key={product.id}>
            <SlideoutFullpageProduct
              isMobile={isMobile}
              product={product}
              selectedVariant={selectedVariantInfo[i]}
              theme={theme}
              {...restProps}
            />
          </Fragment>
        ))}
      </PopupCrossSellOfferCon>
    </StyledSlideoutFullpagePopupWidgetCon>
  );
}

SlideoutFullpageLayout.propTypes = {
  isAdmin: PropTypes.bool,
  isAdminMobileTab: PropTypes.bool,
  isMobile: PropTypes.bool,
  primary: PropTypes.object,
  products: PropTypes.array,
  selectedVariantInfo: PropTypes.array,
  theme: PropTypes.object,
  popupOfferHeaderStyles: PropTypes.object,
  popupOfferBottomBarStyles: PropTypes.object,
  onAddClick: PropTypes.func,
  onMinimizeClick: PropTypes.func,
  onCheckoutClick: PropTypes.func,
  onSkipClick: PropTypes.func,
  isBottomBarButtonActionLoading: PropTypes.bool,
  offerLevelQuantityAdded: PropTypes.number,
  offerLevelDiscountQuantity: PropTypes.number,
  atcStatus: PropTypes.string,
};
